export default [
    {
        path: '/staff',
        name: 'Team',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        components: {
            default: () => import('@views/staff/StaffIndex.vue'),
        },
    },
    {
        path: '/staff/:companyId/create',
        name: 'TeamCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Create team member',
        },
        props: true,
        components: {
            default: () => import('@views/staff/StaffCreate.vue'),
        },
    },
    {
        path: '/companies/:companyId/staff/:staffId/edit',
        name: 'CompanyTeamEdit',
        props: {
            default: (route) => ({
                companyId: route.params.companyId,
                staffId: route.params.staffId,
            }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Edit team member',
        },
        components: {
            default: () => import('@views/staff/StaffEdit.vue'),
        },
    },
    {
        path: '/staff/:staffId/edit',
        name: 'TeamEdit',
        props: {
            default: (route) => ({
                staffId: route.params.staffId,
            }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Edit team member',
        },
        components: {
            default: () => import('@views/staff/StaffMuvalEdit.vue'),
        },
    },
];
